import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Collapse } from '../Collapse';

import './Accordion.css';

/**
 * @deprecated components/Accordion is deprecated, use components/AccordionV2
 */
class Accordion extends Component {
  constructor(props) {
    super(props);
    const { items, collapsed } = props;
    const selectedItems = collapsed ? [] : items.map((item) => item.id);
    this.state = {
      selectedItems,
    };
  }

  toggleItem(item) {
    const { id } = item;
    const { allowMultiple, trackClicked } = this.props;
    const { selectedItems } = this.state;
    const isOpen = selectedItems.indexOf(id) >= 0;
    if (trackClicked && !isOpen) {
      trackClicked(item);
    }
    let updatedItems = [];
    if (allowMultiple) {
      updatedItems = isOpen ? selectedItems.filter((i) => i !== id) : [...selectedItems, id];
    } else if (!isOpen) {
      updatedItems = [id];
    }

    return this.setState(() => ({ selectedItems: updatedItems }));
  }

  renderTitle() {
    const { title } = this.props;
    if (title && typeof title === 'string') {
      return <h2 className="accordion-container__title">{title}</h2>;
    }
    return title;
  }

  render() {
    const { items, className, arrowOnLeft, title } = this.props;
    const { selectedItems } = this.state;

    return (
      <div className="accordion-container">
        {title && <div className="accordion-container__title-container">{this.renderTitle()}</div>}
        <div className={cx('accordion', className)}>
          {items &&
            items.map((item) => {
              const isOpen = selectedItems.indexOf(item.id) >= 0;
              return (
                <div
                  className={cx('accordion__section', {
                    'accordion__section--open': isOpen,
                  })}
                  key={item.id}
                >
                  <button
                    onClick={() => this.toggleItem(item)}
                    type="button"
                    className={cx('accordion__button', {
                      'accordion__button--leftAlign': arrowOnLeft,
                    })}
                  >
                    <span className="accordion__section-heading">{item.hed}</span>
                    <i
                      className={cx('accordion__chevron', {
                        'accordion__chevron--left': arrowOnLeft,
                        'zola-ui-icon-chevron-up': isOpen,
                        'zola-ui-icon-chevron-down': !isOpen,
                      })}
                    />
                  </button>
                  <Collapse isOpen={isOpen}>
                    <div className="accordion__body">{item.dek}</div>
                  </Collapse>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

Accordion.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      hed: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      dek: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ).isRequired,

  /* Whether multiple items are allowed to be open simultaneously */
  allowMultiple: PropTypes.bool,

  /* Whether the arrow appears on the left or the right (default) */
  arrowOnLeft: PropTypes.bool,

  /* Whether the initial state is collapsed (default) or open */
  collapsed: PropTypes.bool,

  /** Callback when an item is expanded */
  trackClicked: PropTypes.func,
};

Accordion.defaultProps = {
  allowMultiple: false,
  arrowOnLeft: false,
  collapsed: true,
};

export default Accordion;
